import $ajax from "../request"
// import { getUrlQueryValueByKey } from "./util";

const BaseUrl = location.origin;

const getDetail = () => {
    return new Promise(resolve => {
        $ajax.get(BaseUrl + '/app/wx/goods/getSelloutList ', {}).then(res => {
            const { data } = res;
            resolve(data);
        })
    })
}

export {
    getDetail
}